








































































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { db, firestore } from "@/scripts/firebase";
import {
  JinroGameDocument,
  JinroPlayerDocument,
  JinroRoomDocument
} from "@/services/datatypes";
import { collectionName } from "@/services/collection-name";
import { ToastProgrammatic as Toast } from "buefy";
import { TOAST_DURATION_MILLISECONDS } from "@/services/constants";
import { JinroRoomStatus } from "../../services/jinro-room-status";
import { DialogProgrammatic as Dialog } from "buefy";
import { UserStatusState } from "../../services/user-status-state";
import { onlineTimeSince } from "@/utils/utils";
import {
  UranaishiOptions,
  KaryudoOptions,
  KaryudoOptionDefault
} from "../../services/jinrogame-options";
import Karyudo from "../JinroPlayer/Night/NightEachRoles/Karyudo.vue";

@Component({
  components: {}
})
export default class StartingJinroGame extends Vue {
  @Prop() readonly jinroRoom!: JinroRoomDocument;
  minJinroNum = 1;
  jinroNum = this.minJinroNum;
  minKyojinNum = 0;
  kyojinNum = this.minKyojinNum;
  minUranaishiNum = 0;
  uranaishiNum = this.minUranaishiNum;
  minReibaishiNum = 0;
  reibaishiNum = this.minReibaishiNum;
  minKaryudoNum = 0;
  karyudoNum = this.minKaryudoNum;

  defaultMaxUranaishiNum = 3;
  defaultMaxReibaishiNum = 3;
  defaultMaxKaryudoNum = 1;

  daytimeMin = 8;
  nighttimeSeconds = 30;

  uranaishiOptionRadio: UranaishiOptions | null = null;
  karyudoOptionRadio: KaryudoOptions | null = null;

  get isOwner() {
    return (
      this.$store.state.firebaseUser &&
      this.jinroRoom.owner === this.$store.state.firebaseUser.uid
    );
  }
  get murabitoNum(): number {
    return (
      this.playerNumber -
      this.jinroNum -
      this.kyojinNum -
      this.uranaishiNum -
      this.reibaishiNum -
      this.karyudoNum
    );
  }

  get playerNumber(): number {
    const players = this.$store.state.jinroRoomPlayers;
    if (players) {
      return players.length;
    }
    return 0;
  }
  get maxReibaishiNum(): number {
    if (this.murabitoNum - 1 < 0) {
      return 0;
    }
    return this.defaultMaxReibaishiNum;
  }

  get maxUranaishiNum(): number {
    if (this.murabitoNum - 1 < 0) {
      return 0;
    }
    return this.defaultMaxUranaishiNum;
  }

  get maxKaryudoNum(): number {
    if (this.murabitoNum - 1 < 0) {
      return 0;
    }
    return this.defaultMaxKaryudoNum;
  }

  get maxJinroKyojinNum(): number {
    if (this.murabitoNum - 1 < 0) {
      return 0;
    }
    // 人狼と狂人の数はプレイヤー全体の数の半分より以下
    const maxJinroKyojinNum =
      this.playerNumber % 2 == 0
        ? Math.floor(this.playerNumber / 2) - 1
        : Math.floor(this.playerNumber / 2);
    return maxJinroKyojinNum;
  }
  get maxJinroNum(): number {
    return this.maxJinroKyojinNum - this.kyojinNum;
  }
  get maxKyojinNum(): number {
    return this.maxJinroKyojinNum - this.jinroNum;
  }

  get insufficientPlayerNumber(): string {
    if (this.murabitoNum < 0) {
      return "プレイヤーの数が足りません。役職者の数を減らしてください";
    }
    return "";
  }
  get ruleDisabled(): boolean {
    if (this.murabitoNum < 0 || this.playerNumber == 1) {
      return true;
    }
    return false;
  }

  get uranaishiOptionOn(): string {
    return UranaishiOptions.FirstDayShiroUranaiOn;
  }
  get uranaishiOptionOff(): string {
    return UranaishiOptions.FirstDayUranaiOff;
  }

  get uranaishiExisted(): boolean {
    return this.uranaishiNum > 0;
  }

  @Watch("uranaishiNum")
  onChangeUranaiNum() {
    if (this.uranaishiNum === 0) this.uranaishiOptionRadio = null;
    if (this.uranaishiNum !== 0 && this.uranaishiOptionRadio === null) {
      const uranaishiOptionDefault = UranaishiOptions.FirstDayShiroUranaiOn;
      this.uranaishiOptionRadio = uranaishiOptionDefault;
    }
  }

  get karyudoOptionOn(): string {
    return KaryudoOptions.RenzokuGoeiOn;
  }
  get karyudoOptionOff(): string {
    return KaryudoOptions.RenzokuGoeiOff;
  }
  get karyudoExisted(): boolean {
    return this.karyudoNum > 0;
  }
  @Watch("karyudoNum")
  onChangeKaryudoNum() {
    if (this.karyudoNum === 0) this.karyudoOptionRadio = null;
    if (this.karyudoNum !== 0 && this.karyudoOptionRadio === null) {
      this.karyudoOptionRadio = KaryudoOptionDefault;
    }
  }

  async updateJinroRoom() {
    await db
      .collection(collectionName.jinrorooms)
      .doc(this.$route.params.jinroRoomId)
      .set(
        {
          jinroRoomStatus: JinroRoomStatus.ProcessingNewGame,
          timeUpdated: firestore.FieldValue.serverTimestamp()
        },
        { merge: true }
      );
    return;
  }

  get ownerPlayerId(): string {
    if (this.$store.state.jinroRoomPlayers) {
      const players = this.$store.state.jinroRoomPlayers as Array<
        JinroPlayerDocument
      >;
      const user = players.find(player => {
        return player.uid === this.jinroRoom.owner;
      }) as JinroPlayerDocument;

      return user.id;
    }

    return "";
  }

  dialogue() {
    Dialog.confirm({
      message: this.dialogueMessage,
      cancelText: "キャンセル",
      confirmText: "ゲームを開始する",
      onConfirm: async () => this.createJinroGame()
    });
  }

  get dialogueMessage(): string {
    let msg = `以下のルールでゲームを開始しますか<br/>`;
    if (this.murabitoNum > 0) {
      msg += `<br/>・村人 ${this.murabitoNum}人`;
    }
    if (this.jinroNum > 0) {
      msg += `<br/>・人狼 ${this.jinroNum}人`;
    }
    if (this.kyojinNum > 0) {
      msg += `<br/>・狂人 ${this.kyojinNum}人`;
    }
    if (this.uranaishiNum > 0) {
      msg += `<br/>・占い師 ${this.uranaishiNum}人`;
    }
    if (this.karyudoNum > 0) {
      msg += `<br/>・狩人 ${this.karyudoNum}人`;
    }
    if (this.reibaishiNum > 0) {
      msg += `<br/>・霊媒師 ${this.reibaishiNum}人`;
    }
    msg += `<br/><br/>合計 ${this.playerNumber}人`;
    if (this.uranaishiExisted) {
      let uranaiOption = "占い師オプション: ";
      uranaiOption +=
        this.uranaishiOptionRadio === UranaishiOptions.FirstDayShiroUranaiOn
          ? "初日占い有(人間のみ)"
          : "初日占い無し";
      msg += "<hr/>";
      msg += `・${uranaiOption}`;
    }
    if (this.karyudoExisted) {
      let karyudoOption = "狩人オプション: ";
      karyudoOption +=
        this.karyudoOptionRadio === KaryudoOptions.RenzokuGoeiOn
          ? "連続護衛有り"
          : "連続護衛無し";
      msg += "<hr/>";
      msg += `・${karyudoOption}`;
    }

    msg += "<hr/>";
    msg += `・昼時間 ${this.daytimeMin}分`;
    msg += `<br/>・夜時間 ${this.nighttimeSeconds}秒`;

    const offlinePlayes = this.getOfflinePlayers;
    if (offlinePlayes.length > 0) {
      msg += "<hr/>";
      msg += `<strong>以下のプレイヤーがオフラインの可能性があります</strong>`;
      msg += "<ul>";
      offlinePlayes.forEach(player => {
        if (!player.userStatus) {
          return;
        }
        const time = player.userStatus
          .timeLastChanged as firebase.firestore.Timestamp;
        const timeLastChanged = time.toDate();

        const timeFromNow = onlineTimeSince(timeLastChanged);
        msg += `<li>・${player.playerName}    ${timeFromNow}</li>`;
      });
      msg += "</ul>";
    }

    return msg;
  }

  get getOfflinePlayers(): Array<JinroPlayerDocument> {
    if (!this.$store.state.jinroRoomPlayers) {
      return [];
    }
    const roomPlayers = this.$store.state.jinroRoomPlayers as Array<
      JinroPlayerDocument
    >;
    const offlinePlayers = roomPlayers.filter(player => {
      return (
        player.userStatus && player.userStatus.state === UserStatusState.Offline
      );
    });
    return offlinePlayers;
  }

  async createJinroGame() {
    await this.updateJinroRoom();
    let gameParams: JinroGameDocument = {
      jinroRoomId: this.$route.params.jinroRoomId,
      jinroRoomTitle: this.jinroRoom.title,
      owner: this.$store.state.firebaseUser.uid,
      ownerName: this.$store.state.user.displayName,
      playerNum: this.playerNumber,
      players: this.$store.state.jinroRoomPlayers,
      survivors: this.$store.state.jinroRoomPlayers,
      murabitoNum: this.murabitoNum,
      jinroNum: this.jinroNum,
      kyojinNum: this.kyojinNum,
      uranaishiNum: this.uranaishiNum,
      reibaishiNum: this.reibaishiNum,
      karyudoNum: this.karyudoNum,

      daytimeSeconds: this.daytimeMin * 60,
      nighttimeSeconds: this.nighttimeSeconds,

      isNextPlayQueueProcessing: false,
      killedPlayers: [],
      killedPlayersByJinroAttack: [],
      gmMessage: "",
      gmTemporaryMessage: "",
      hasBeenGameEnded: false
    };
    if (this.uranaishiExisted) {
      gameParams = {
        ...gameParams,
        uranaishiOption: this.uranaishiOptionRadio as UranaishiOptions
      };
    }
    if (this.karyudoExisted) {
      gameParams = {
        ...gameParams,
        karyudoOption: this.karyudoOptionRadio as KaryudoOptions
      };
    }

    await db.collection(collectionName.jinrogames).add({
      ...gameParams,
      timeCreated: firestore.FieldValue.serverTimestamp()
    });
    this.openToast();
  }

  openToast(): void {
    Toast.open({
      duration: TOAST_DURATION_MILLISECONDS,
      type: "is-success",
      queue: false,
      message: "人狼ゲームが作成されます"
    });
  }
  cancelEdit() {
    this.$emit("cancel-edit", "");
  }

  async handleStartGame() {
    this.dialogue();
  }
}
